import React from "react";
import { Link } from "react-router-dom";

import heroBg from "../../images/bg/hero_bg.png";

const VerificationCard: React.FC = () => (
  <div className="vc-wrap">
    {/* Header */}
    <div className="vc-header">
      <div className="vc-header-dot" />
      <span className="vc-header-dot" style={{ background: "#febc2e" }} />
      <span className="vc-header-dot" style={{ background: "#28c840" }} />
      <span className="vc-header-title">TrustEngine · eKYC Result</span>
    </div>

    {/* Avatar + name */}
    <div className="vc-identity">
      <div className="vc-avatar">
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="40" height="40">
          <circle cx="32" cy="24" r="13" fill="rgba(0,200,150,0.2)" stroke="#00c896" strokeWidth="1.5"/>
          <path d="M10 58 C10 42 54 42 54 58" fill="rgba(0,200,150,0.15)" stroke="#00c896" strokeWidth="1.5"/>
        </svg>
        <div className="vc-avatar-badge">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </div>
      </div>
      <div>
        <div className="vc-name">Rian Hidayat</div>
        <div className="vc-sub">KTP · Indonesian Citizen</div>
      </div>
      <div className="vc-verified-badge">✓ Verified</div>
    </div>

    {/* Divider */}
    <div className="vc-divider" />

    {/* Checks */}
    {[
      { label: "Face Match",     value: "98.4%", pct: 98, color: "#00c896" },
      { label: "Liveness",       value: "PASS",  pct: 100, color: "#00c896" },
      { label: "Doc. Authentic", value: "VALID", pct: 94, color: "#00c896" },
    ].map((row, i) => (
      <div className="vc-row" key={i} style={{ animationDelay: `${i * 0.15}s` }}>
        <span className="vc-row-label">{row.label}</span>
        <div className="vc-bar-wrap">
          <div className="vc-bar" style={{ width: `${row.pct}%`, background: row.color }} />
        </div>
        <span className="vc-row-value" style={{ color: row.color }}>{row.value}</span>
      </div>
    ))}

    {/* Footer */}
    <div className="vc-footer">
      <span className="vc-speed">⚡ Verified in 1.2s</span>
      <span className="vc-api">via /v1/ekyc/verify</span>
    </div>
  </div>
);

const ArrowSVG = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="5.06592" y="19.9785" width="20.5712" height="2.61221" transform="rotate(-40.2798 5.06592 19.9785)" fill="white" />
    <rect x="7.97095" y="7.24463" width="2.61221" height="2.61221" transform="rotate(-40.2798 7.97095 7.24463)" fill="white" />
    <rect x="11.6523" y="7.54834" width="2.61221" height="2.61221" transform="rotate(-40.2798 11.6523 7.54834)" fill="white" />
    <rect x="15.334" y="7.85205" width="2.61221" height="2.61221" transform="rotate(-40.2798 15.334 7.85205)" fill="white" />
    <rect x="18.7119" y="11.8374" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.7119 11.8374)" fill="white" />
    <rect x="18.4084" y="15.52" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.4084 15.52)" fill="white" />
    <rect x="18.104" y="19.2012" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.104 19.2012)" fill="white" />
  </svg>
);

const HeroSection: React.FC = () => {
  return (
    <section
      className="hero hero-style pos-rel bg_img"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      <div className="container">
        <div className="row">
          {/* ---------- Left Content ---------- */}
          <div className="col-lg-9 col-md-12 col-12">
            <div className="hero-content">
              <h2 className="title scale-animation wow">
                Verify Identities in Seconds, Not Days
              </h2>
              <p className="sub-title scale-animation wow">
                Enterprise-grade identity verification API. eKYC, face recognition,
                liveness detection, and document OCR — all in one platform.
                Integrate in minutes, scale to millions.
              </p>
              <div
                className="hero-btn scale-animation wow"
                style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}
              >
                <Link className="thm-btn agency-btn" to="/contact">
                  <span className="text">Start Free Trial</span>
                  <span className="arrow">
                    <span className="arrow-icon">
                      <ArrowSVG />
                      <ArrowSVG />
                    </span>
                  </span>
                </Link>
              </div>
            </div>
          </div>

          {/* ---------- Right: Verification Card ---------- */}
          <div className="col-lg-3 d-none d-lg-flex align-items-center justify-content-center" style={{ paddingTop: 60 }}>
            <VerificationCard />
          </div>
        </div>

        {/* ---------- Feature Cards ---------- */}
        <style>{`
          @keyframes fc-arc   { from{stroke-dashoffset:251} to{stroke-dashoffset:7} }
          @keyframes fc-scan  { 0%,100%{transform:translateY(0);opacity:.6} 50%{transform:translateY(54px);opacity:1} }
          @keyframes fc-blink { 0%,100%{opacity:.2} 50%{opacity:1} }
          @keyframes fc-flow  { 0%{left:-5%;opacity:0} 15%{opacity:1} 85%{opacity:1} 100%{left:105%;opacity:0} }
          @keyframes fc-step  { from{opacity:0;transform:translateX(-8px)} to{opacity:1;transform:translateX(0)} }
          @keyframes fc-bpop  { from{transform:scale(0.4);opacity:0} to{transform:scale(1);opacity:1} }
          @keyframes fc-pulse { 0%,100%{transform:scale(1);opacity:.1} 50%{transform:scale(1.15);opacity:.25} }
          @keyframes fc-live  { 0%,100%{opacity:1} 50%{opacity:.3} }
        `}</style>

        <div className="row" style={{ marginTop: "auto", paddingTop: 32 }}>
          <div className="col-lg-12">
            <div style={{
              background: "#ffffff", borderRadius: "20px",
              border: "1px solid rgba(15,32,64,0.08)",
              boxShadow: "0 8px 40px rgba(15,32,64,0.1)",
              overflow: "hidden",
            }}>

              {/* ── Window header bar ── */}
              <div style={{ padding: "10px 20px", background: "rgba(15,32,64,0.025)", borderBottom: "1px solid rgba(15,32,64,0.06)", display: "flex", alignItems: "center", gap: "6px" }}>
                <span style={{ width:10, height:10, borderRadius:"50%", background:"#ff5f57", display:"inline-block" }}/>
                <span style={{ width:10, height:10, borderRadius:"50%", background:"#febc2e", display:"inline-block" }}/>
                <span style={{ width:10, height:10, borderRadius:"50%", background:"#28c840", display:"inline-block" }}/>
                <span style={{ fontSize:12, color:"#6b7280", marginLeft:10, fontFamily:"monospace" }}>TrustEngine API — Live Verification</span>
                <span style={{ marginLeft:"auto", fontSize:10, fontWeight:700, color:"#00c896", animation:"fc-live 1.4s ease-in-out infinite" }}>● LIVE</span>
              </div>

              {/* ── 3 panels ── */}
              <div className="hero-feature-grid" style={{ display:"grid", gridTemplateColumns:"1fr 48px 1fr 48px 1fr" }}>

                {/* Panel 1: Accuracy */}
                <div style={{ padding:"24px 28px 22px", borderRight:"1px solid rgba(15,32,64,0.06)" }}>
                  <div style={{ display:"flex", justifyContent:"center", marginBottom:14 }}>
                    <svg width="110" height="110" viewBox="0 0 120 120" onAnimationEnd={(e)=>e.stopPropagation()}>
                      <defs>
                        <linearGradient id="fcArcG" x1="0" y1="0" x2="1" y2="1">
                          <stop offset="0%" stopColor="#00c896"/>
                          <stop offset="100%" stopColor="#3b82f6"/>
                        </linearGradient>
                      </defs>
                      <circle cx="60" cy="60" r="38" fill="none" stroke="rgba(15,32,64,0.06)" strokeWidth="7"/>
                      <circle cx="60" cy="60" r="38" fill="none" stroke="url(#fcArcG)" strokeWidth="7"
                        strokeLinecap="round" transform="rotate(-90 60 60)"
                        style={{ strokeDasharray:239, strokeDashoffset:239, animation:"fc-arc 2s .6s ease forwards" }}/>
                      <circle cx="48" cy="54" r="2.2" fill="#0f2040" style={{ animation:"fc-blink 1.6s 0s infinite" }}/>
                      <circle cx="72" cy="54" r="2.2" fill="#0f2040" style={{ animation:"fc-blink 1.6s .3s infinite" }}/>
                      <path d="M51 69 Q60 76 69 69" stroke="#00c896" strokeWidth="2" strokeLinecap="round" fill="none" style={{ animation:"fc-blink 1.6s .6s infinite" }}/>
                      <rect x="37" y="40" width="46" height="1.4" rx="1" fill="rgba(0,200,150,0.55)" style={{ animation:"fc-scan 2.6s ease-in-out infinite" }}/>
                      {["M37 46 L37 40 L43 40","M83 46 L83 40 L77 40","M37 74 L37 80 L43 80","M83 74 L83 80 L77 80"].map((d,i)=>(
                        <path key={i} d={d} stroke="#00c896" strokeWidth="1.6" strokeLinecap="round" fill="none"/>
                      ))}
                      <text x="60" y="64" textAnchor="middle" fontSize="13" fontWeight="800" fill="#0f2040" fontFamily="system-ui,sans-serif">99.97%</text>
                    </svg>
                  </div>
                  <div style={{ fontSize:16, fontWeight:800, color:"#0f2040", marginBottom:6 }}>99.97% Accuracy</div>
                  <div style={{ fontSize:13, color:"#6b7280", lineHeight:1.6 }}>Industry-leading AI verification engine with sub-second response time and minimal false positives.</div>
                </div>

                {/* Connector 1 */}
                <div className="hero-feature-connector" style={{ display:"flex", alignItems:"center", justifyContent:"center" }}>
                  <svg width="48" height="24" viewBox="0 0 48 24" onAnimationEnd={(e)=>e.stopPropagation()}>
                    <path d="M4 12 H40 M34 6 L44 12 L34 18" stroke="rgba(0,200,150,0.4)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                  </svg>
                </div>

                {/* Panel 2: Speed */}
                <div style={{ padding:"24px 28px 22px", borderRight:"1px solid rgba(15,32,64,0.06)" }}>
                  {/* Pipeline */}
                  <div style={{ display:"flex", alignItems:"center", gap:0, marginBottom:14, position:"relative" }}>
                    {[
                      { label:"INPUT",  color:"#0f2040", bg:"rgba(15,32,64,0.07)"   },
                      { label:"OCR",    color:"#3b82f6", bg:"rgba(59,130,246,0.1)"  },
                      { label:"AI",     color:"#8b5cf6", bg:"rgba(139,92,246,0.1)"  },
                      { label:"RESULT", color:"#00c896", bg:"rgba(0,200,150,0.1)"   },
                    ].map((s,i)=>(
                      <React.Fragment key={i}>
                        <div style={{ flex:1, background:s.bg, border:`1px solid ${s.color}28`, borderRadius:8, padding:"7px 4px", textAlign:"center" }}>
                          <div style={{ fontSize:9, fontWeight:800, color:s.color, letterSpacing:"0.06em" }}>{s.label}</div>
                        </div>
                        {i<3 && <div style={{ width:14, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                          <svg width="12" height="8" viewBox="0 0 12 8" onAnimationEnd={(e)=>e.stopPropagation()}><path d="M0 4h8M7 1l3 3-3 3" stroke="rgba(15,32,64,0.2)" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none"/></svg>
                        </div>}
                      </React.Fragment>
                    ))}
                    {/* Flow dots */}
                    <div style={{ position:"absolute", top:"50%", left:0, right:0, height:2, overflow:"hidden", marginTop:-1, pointerEvents:"none" }}>
                      {[0,1,2].map(i=>(
                        <div key={i} style={{ position:"absolute", width:7, height:7, borderRadius:"50%", background:"#00c896", top:-2.5, left:0, boxShadow:"0 0 5px #00c896", animation:`fc-flow 2.4s ${i*0.8}s ease-in-out infinite` }}/>
                      ))}
                    </div>
                  </div>
                  {/* Step timings */}
                  {[
                    { label:"Document capture",    time:"0.3s", delay:"0.3s" },
                    { label:"Face + liveness check",time:"0.7s", delay:"0.7s" },
                    { label:"Decision returned",   time:"1.2s", delay:"1.1s" },
                  ].map(s=>(
                    <div key={s.label} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 0", borderBottom:"1px solid rgba(15,32,64,0.05)", animation:`fc-step .4s ${s.delay} both` }}>
                      <span style={{ fontSize:12, color:"#6b7280" }}>{s.label}</span>
                      <span style={{ fontSize:12, fontWeight:700, color:"#00c896", fontFamily:"monospace" }}>{s.time}</span>
                    </div>
                  ))}
                  <div style={{ marginTop:14, fontSize:16, fontWeight:800, color:"#0f2040", marginBottom:6 }}>&lt;3 Second Checks</div>
                  <div style={{ fontSize:13, color:"#6b7280", lineHeight:1.6 }}>Real-time identity verification at any scale — from 1,000 to 5 million monthly checks without slowdown.</div>
                </div>

                {/* Connector 2 */}
                <div className="hero-feature-connector" style={{ display:"flex", alignItems:"center", justifyContent:"center" }}>
                  <svg width="48" height="24" viewBox="0 0 48 24" onAnimationEnd={(e)=>e.stopPropagation()}>
                    <path d="M4 12 H40 M34 6 L44 12 L34 18" stroke="rgba(0,200,150,0.4)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                  </svg>
                </div>

                {/* Panel 3: Compliance */}
                <div style={{ padding:"24px 28px 22px" }}>
                  <div style={{ display:"flex", justifyContent:"center", marginBottom:14 }}>
                    <svg width="110" height="110" viewBox="0 0 120 120" onAnimationEnd={(e)=>e.stopPropagation()}>
                      <circle cx="60" cy="60" r="50" fill="none" stroke="rgba(0,200,150,0.08)" strokeWidth="1.5" style={{ animation:"fc-pulse 3s ease-in-out infinite" }}/>
                      <circle cx="60" cy="60" r="40" fill="none" stroke="rgba(0,200,150,0.1)" strokeWidth="1" strokeDasharray="4 3"/>
                      <path d="M60 24 L40 32v16c0 14 9 27 20 31 11-4 20-17 20-31V32L60 24z" fill="rgba(0,200,150,0.07)" stroke="#00c896" strokeWidth="1.8" strokeLinejoin="round"/>
                      <path d="M51 48l6 6 12-12" stroke="#00c896" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                      {[
                        { angle:-60, label:"ISO",  color:"#00c896", delay:"0.4s" },
                        { angle: 30, label:"GDPR", color:"#3b82f6", delay:"0.7s" },
                        { angle:120, label:"PDPA", color:"#8b5cf6", delay:"1.0s" },
                        { angle:210, label:"OJK",  color:"#f59e0b", delay:"1.3s" },
                      ].map(({angle,label,color,delay})=>{
                        const r=(angle*Math.PI)/180, x=60+40*Math.cos(r), y=60+40*Math.sin(r);
                        return (
                          <g key={label} style={{ animation:`fc-bpop .4s ${delay} both` }}>
                            <circle cx={x} cy={y} r="12" fill={`${color}18`} stroke={`${color}55`} strokeWidth="1.2"/>
                            <text x={x} y={y+4} textAnchor="middle" fontSize="7" fontWeight="800" fill={color} fontFamily="system-ui,sans-serif">{label}</text>
                          </g>
                        );
                      })}
                    </svg>
                  </div>
                  <div style={{ fontSize:16, fontWeight:800, color:"#0f2040", marginBottom:6 }}>ISO 27001 Certified</div>
                  <div style={{ fontSize:13, color:"#6b7280", lineHeight:1.6 }}>Bank-grade security with global compliance — GDPR, PDPA, and OJK compliant out of the box.</div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
